import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { authLogin } from "../api/auth";
import { getUser } from "../api/users";
import { USER_TYPE } from "../const/enums";
import { userAtom } from "../store/user";

export default function useUserActions() {
  const [user, setUser] = useRecoilState(userAtom);
  const navigate = useNavigate();

  const login = async (email, password) => {
    console.log("attempting login..");
    await authLogin(email, password)
      .then(async (data) => {
        localStorage.setItem("access-token", data.access);
        await getUser(data.user.pk).then((userData) => {
          console.log(`user: ${JSON.stringify(userData)}`);
          setUser(userData);
        });
      })
      .then(() => {
        if ([USER_TYPE.CHIEF, USER_TYPE.ASSISTANT].includes(user.user_type)) {
          navigate("/chief_dashboard");
        } else {
          navigate("/");
        }
      });
  };

  return [login];
}
